import { mapGetters, mapActions } from 'vuex'
import { FIREBASE_CLIENT_STATUS, FIREBASE_NOTIFY_CODE, FIREBASE_ORDER_STATUS } from '../../helpers/enum'

export default {
  data() {
    return {
      isShowNotificationDropdown: false,
      NEED_APPROVE_ACCESS_STATUSES: [
        FIREBASE_NOTIFY_CODE.REQUEST_APPROVE_ACCESS,
      ],
      NEED_APPROVE_ORDERS_STATUSES: [
        FIREBASE_NOTIFY_CODE.REQUEST_APPROVE_ORDERS,
      ],
    }
  },

  computed: {
    ...mapGetters({
      notifications: 'getNotifications',
      unreadNotificationCount: 'unreadNotificationCount',
    }),
  },

  methods: {
    ...mapActions([
      'updateNotify',
      'updateNotifies',
      'updateClient',
      'updateOrder',
      'setPosSection',
      'setPosSelectedQueue',
    ]),
    handleClickNotificationBell() {
      this.isShowNotificationDropdown = !this.isShowNotificationDropdown
    },
    handleClickReadNotify(notify) {
      this.updateNotify({
        queueNumber: notify.queue_number,
        notifyId: notify.notify_id,
        payload: {
          is_read: true,
        },
      })
    },
    handleClickReadNotifyAll() {
      const unreadNotifies = this.notifications.filter((item) => !item.is_read)
      if (unreadNotifies.length) {
        this.updateNotifies({
          notifies: unreadNotifies,
          payload: {
            is_read: true,
          },
        })
      }
    },
    handleClickReject(notify) {
      if (this.NEED_APPROVE_ACCESS_STATUSES.includes(notify.code)) {
        this.updateClientStatus(notify, FIREBASE_CLIENT_STATUS.REJECTED)
      }
      else if (this.NEED_APPROVE_ORDERS_STATUSES.includes(notify.code)) {
        this.updateOrderStatus(notify, FIREBASE_ORDER_STATUS.REJECTED)
      }
    },
    handleClickApprove(notify) {
      if (this.NEED_APPROVE_ACCESS_STATUSES.includes(notify.code)) {
        this.updateClientStatus(notify, FIREBASE_CLIENT_STATUS.APPROVED)
      }
      else if (this.NEED_APPROVE_ORDERS_STATUSES.includes(notify.code)) {
        this.updateOrderStatus(notify, FIREBASE_ORDER_STATUS.APPROVED)
      }
    },
    handleClickViewOrderNo(notify) {
      this.setPosSelectedQueue(notify.queue_number)
      this.setPosSection('choose-product')
      this.isShowNotificationDropdown = false

      if (!notify.is_read) {
        this.updateNotify({
          queueNumber: notify.queue_number,
          notifyId: notify.notify_id,
          payload: {
            is_read: true,
          },
        })
      }

      if (this.setUI) {
        this.$nextTick(() => {
          this.setUI()
        })
      }
    },
    updateClientStatus(notify, clientStatus) {
      this.updateClient({
        clientId: notify.metadata.client_id,
        payload: {
          clientStatus: clientStatus,
        },
      })
      this.updateNotify({
        queueNumber: notify.queue_number,
        notifyId: notify.notify_id,
        payload: {
          is_read: true,
          metadata: {
            ...notify.metadata,
            responseStatus: clientStatus,
          },
        },
      })
    },
    updateOrderStatus(notify, orderStatus) {
      let orders = []

      if (notify.metadata.order) {
        orders = [
          notify.metadata.order,
        ]
      } else if (notify.metadata.orders) {
        orders = notify.metadata.orders
      }

      for (let i = 0; i < orders.length; i++) {
        const order = orders[i]
        this.updateOrder({
          queueNumber: notify.queue_number,
          orderId: order.order_id,
          payload: {
            status: orderStatus,
          },
        })
      }

      this.updateNotify({
        queueNumber: notify.queue_number,
        notifyId: notify.notify_id,
        payload: {
          is_read: true,
          metadata: {
            ...notify.metadata,
            responseStatus: orderStatus,
          },
        },
      })
    },
    getNotifyDetailText(metadata) {
      const getOrderText = (order) => `${order.item} x${order.quantity}`
      if (metadata.order) {
        return [
          {
            item: getOrderText(metadata.order),
            modifiers: metadata.order.modifiers || [],
          },
        ]
      } else if (metadata.orders) {
        return metadata.orders.map((order) => ({
          item: getOrderText(order),
          modifiers: order.modifiers || [],
        }))
      } else {
        return []
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/pos/notification.js